import { useEffect as e } from "react";
import { enUS as t } from "date-fns/locale/en-US";
import { LanguageCodeEnum as n } from "@systemeio/types";
//#region src/date-picker/utils/use-date-fns-locale.ts
function r(r, i) {
	e(() => {
		let e = !0;
		return (async () => {
			try {
				if (!r) {
					e && i(t);
					return;
				}
				let a;
				switch (r) {
					case n.ENGLISH:
						a = t;
						break;
					case n.CHINESE:
						a = (await import("date-fns/locale/zh-CN")).zhCN;
						break;
					case n.ARABIC:
						a = (await import("date-fns/locale/ar")).ar;
						break;
					case n.CZECH:
						a = (await import("date-fns/locale/cs")).cs;
						break;
					case n.DANISH:
						a = (await import("date-fns/locale/da")).da;
						break;
					case n.DEUTSCH:
						a = (await import("date-fns/locale/de")).de;
						break;
					case n.GREEK:
						a = (await import("date-fns/locale/el")).el;
						break;
					case n.SPANISH:
						a = (await import("date-fns/locale/es")).es;
						break;
					case n.FRENCH:
						a = (await import("date-fns/locale/fr")).fr;
						break;
					case n.HINDI:
						a = (await import("date-fns/locale/hi")).hi;
						break;
					case n.HUNGARIAN:
						a = (await import("date-fns/locale/hu")).hu;
						break;
					case n.INDONESIAN:
						a = (await import("date-fns/locale/id")).id;
						break;
					case n.ITALIAN:
						a = (await import("date-fns/locale/it")).it;
						break;
					case n.JAPANESE:
						a = (await import("date-fns/locale/ja")).ja;
						break;
					case n.NORWEGIAN:
						a = (await import("date-fns/locale/nb")).nb;
						break;
					case n.DUTCH:
						a = (await import("date-fns/locale/nl")).nl;
						break;
					case n.POLISH:
						a = (await import("date-fns/locale/pl")).pl;
						break;
					case n.PORTUGUESE:
						a = (await import("date-fns/locale/pt")).pt;
						break;
					case n.ROMANIAN:
						a = (await import("date-fns/locale/ro")).ro;
						break;
					case n.RUSSIAN:
						a = (await import("date-fns/locale/ru")).ru;
						break;
					case n.SLOVAK:
						a = (await import("date-fns/locale/sk")).sk;
						break;
					case n.SLOVENIAN:
						a = (await import("date-fns/locale/sl")).sl;
						break;
					case n.ALBANIA:
						a = (await import("date-fns/locale/sq")).sq;
						break;
					case n.SERBIAN:
						a = (await import("date-fns/locale/sr")).sr;
						break;
					case n.SWEDISH:
						a = (await import("date-fns/locale/sv")).sv;
						break;
					case n.THAI:
						a = (await import("date-fns/locale/th")).th;
						break;
					case n.TURKISH:
						a = (await import("date-fns/locale/tr")).tr;
						break;
					case n.UKRAINIAN:
						a = (await import("date-fns/locale/uk")).uk;
						break;
					default: a = t;
				}
				e && i(a);
			} catch {
				e && i(t);
			}
		})(), () => {
			e = !1;
		};
	}, [r, i]);
}
//#endregion
export { r as useDateFnsLocale };
